import request from "@/utils/request";
/**
 *
 * 个人中心及用户登录注册相关
 *
 */

// 系统配置
export function systemConfig() {
  return request({
    url: '/api/config/system',
    method: 'post'
  })
}
// 用户注册
export function userRegister(data) {
  return request({
    url: '/api/user/register',
    method: 'post',
    data
  })
}
// 登录
export function userLogin(data) {
  return request({
    url: '/api/auth/login',
    method: 'post',
    data
  })
}
// 退出登录
export function logout() {
  return request({
    url: '/api/user/logout',
    method: 'post'
  })
}
// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/api/user/info',
    method: 'get'
  })
}
